// src/app.tsx
import * as React from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import { jwtDecode } from "jwt-decode";
import WorkOrdersList from "./views/andqo/home/WorkOrders";
import Category from "./views/andqo/category/CategoryList";
import SignIn from "./views/auth/Login";
import UploadCSV from "./views/sncf/upload/UploadCsv";
import Status from "./views/sncf/status/Status";
import { TokenPayload } from "./api/interfaces";

function isAuthenticated(): boolean {
  const token = localStorage.getItem("access_token");
  console.log(token)
  if (token) {
    const decodedToken = jwtDecode<TokenPayload>(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
  }
  return false;
}

function PrivateRoute({ children }: { children: React.ReactNode }) {
  console.log("hjerererer")
  return isAuthenticated() ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<SignIn />} />
          <Route
            path="/andqo/home"
            element={
              <PrivateRoute>
                <WorkOrdersList />
              </PrivateRoute>
            }
          />
          <Route
            path="/andqo/category"
            element={
              <PrivateRoute>
                <Category />
              </PrivateRoute>
            }
          />
          <Route
            path="/sncf/home"
            element={
              <PrivateRoute>
                <UploadCSV />
              </PrivateRoute>
            }
          />
          <Route
            path="/sncf/status"
            element={
              <PrivateRoute>
                <Status />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </CssVarsProvider>
  );
}
